import script from "./SettingsCountriesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsCountriesSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsCountriesSection.vue?vue&type=style&index=0&id=1280ef22&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1280ef22"]])

export default __exports__